// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SoSYB","input":"styles_input__2ohqN"};